import React from "react";

const LazyBoardsMy = React.lazy(() => import("./BoardsMy").then((m) => ({ default: m.BoardsMy })));

export default LazyBoardsMy;
